import React from 'react';
import styled from 'styled-components';
import { Container, Section } from 'components/shared';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import useBreakpoint from 'utils/hooks/useBreakpoint';
import getEmbedUrl from 'utils/getEmbedUrl';
import { AspectRatio } from 'react-aspect-ratio';
import breakpoints from 'utils/breakpoints';
import getVideoType from 'utils/getVideoType';
import {
  videoTranscriptFileUrl,
  videoTranscriptFileExtension,
} from 'utils/videoTranscriptFileUrl';

const StyledAspectRatio = styled.div`
  @media ${breakpoints.md} {
    max-width: 46%;
  }
`;

const DoubleMedia = ({ fields, rendering }) => {
  const videoLeft = getFieldValue(fields, 'videoLeft') || {};
  const imageLeft = getFieldValue(fields, 'imageLeft');
  const displayOptionLeft = getFieldValue(fields, 'displayOptionLeft');
  const isImageLeft = displayOptionLeft === 'Image';
  const videoRight = getFieldValue(fields, 'videoRight') || {};
  const imageRight = getFieldValue(fields, 'imageRight');
  const displayOptionRight = getFieldValue(fields, 'displayOptionRight');
  const isImageRight = displayOptionRight === 'Image';
  const videoDescriptionLeft = getFieldValue(fields, 'videoAltTextLeft');
  const videoDescriptionRight = getFieldValue(fields, 'videoAltTextRight');
  const videoTranscriptLeft =
    getFieldValue(fields, 'videoAltTranscriptFileLeft') || {};
  const videoTranscriptRight =
    getFieldValue(fields, 'videoAltTranscriptFileRight') || {};

  const breakpoint = useBreakpoint(
    typeof window !== 'undefined' && window.innerWidth,
  );
  const isMobile = ['sm', 'xs'].includes(breakpoint);

  const ratio = isMobile ? '330/237' : '1.5';

  const leftVideoType = getVideoType(videoLeft.href);
  const rightVideoType = getVideoType(videoRight.href);

  return (
    <Section>
      <Container className='flex flex-col md:flex-row justify-between'>
        <StyledAspectRatio className='flex-1 md:mr-4 mb-10 md:mb-0'>
          <AspectRatio ratio={ratio} className=''>
            <div
              key={isImageLeft ? imageLeft.src : videoLeft.id}
              //isMobile={isMobile}
              className='w-full h-full rounded overflow-hidden'
            >
              {isImageLeft && (
                <img
                  src={imageLeft.src}
                  alt={imageLeft.alt}
                  className='min-h-full min-w-full object-cover'
                />
              )}
              {!isImageLeft && leftVideoType === 'external' && (
                <iframe
                  className='min-h-full min-w-full bg-black'
                  src={getEmbedUrl(videoLeft.href, false)}
                />
              )}
              {!isImageLeft && leftVideoType === 'internal' && (
                <video
                  className='min-h-full min-w-full bg-black'
                  src={videoLeft.href}
                  // alt={videoDescriptionLeft}
                  // aria-label={videoDescriptionLeft}
                  controls
                  disablePictureInPicture='true'
                  controlsList='nodownload'
                  // autoPlay
                  muted
                  loop
                />
              )}
            </div>
          </AspectRatio>
          {!isImageLeft &&
            videoDescriptionLeft &&
            videoTranscriptLeft &&
            videoTranscriptLeft.link &&
            videoTranscriptLeft.link.href && (
              <span className='richtext text-left text-md leading-7 font-graphie text-mattamy-blue mt-2'>
                {'Transcript: '}
                <a
                  href={videoTranscriptFileUrl(videoTranscriptLeft)}
                  download={
                    videoTranscriptLeft.name +
                    videoTranscriptFileExtension(videoTranscriptLeft.extension)
                  }
                  className='underline'
                  aria-label={
                    'Download ' + videoDescriptionLeft + ' transcript'
                  }
                >
                  {videoDescriptionLeft}
                </a>
              </span>
            )}
        </StyledAspectRatio>
        <StyledAspectRatio className='flex-1'>
          <AspectRatio ratio={ratio} className=''>
            <div
              key={isImageRight ? imageRight.src : videoRight.id}
              //isMobile={isMobile}
              className='w-full h-full rounded overflow-hidden'
            >
              {isImageRight && (
                <img
                  src={imageRight.src}
                  alt={imageRight.alt}
                  className='min-h-full min-w-full object-cover'
                />
              )}
              {!isImageRight && rightVideoType === 'external' && (
                <iframe
                  className='min-h-full min-w-full bg-black'
                  src={getEmbedUrl(videoRight.href, false)}
                />
              )}
              {!isImageRight && rightVideoType === 'internal' && (
                <video
                  className='min-h-full min-w-full bg-black'
                  src={videoRight.href}
                  // alt={videoDescriptionRight}
                  // aria-label={videoDescriptionRight}
                  controls
                  disablePictureInPicture='true'
                  controlsList='nodownload'
                  // autoPlay
                  muted
                  loop
                />
              )}
            </div>
          </AspectRatio>
          {!isImageRight &&
            videoDescriptionRight &&
            videoTranscriptRight &&
            videoTranscriptRight.link &&
            videoTranscriptRight.link.href && (
              <span className='richtext text-left text-md leading-7 font-graphie text-mattamy-blue mt-2'>
                {'Transcript: '}
                <a
                  href={videoTranscriptFileUrl(videoTranscriptRight)}
                  download={
                    videoTranscriptRight.name +
                    videoTranscriptFileExtension(videoTranscriptRight.extension)
                  }
                  className='underline'
                  aria-label={
                    'Download ' + videoDescriptionRight + ' transcript'
                  }
                >
                  {videoDescriptionRight}
                </a>
              </span>
            )}
        </StyledAspectRatio>
      </Container>
    </Section>
  );
};

export default DoubleMedia;
